import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";
import React from 'react';
import { useField, useFormikContext } from 'formik';
import FeedbackButton from './FeedbackButton';

var SmileField = function SmileField(_ref) {
  var name = _ref.name,
      options = _ref.options,
      onChange = _ref.onChange;

  var _useField = useField(name),
      value = _useField[0].value;

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue;

  return options.map(function (option) {
    return React.createElement(FeedbackButton, {
      style: {
        flex: 1,
        margin: '0 2% 0 2%'
      },
      key: option.icon,
      icon: option.icon,
      iconSize: "2x",
      value: option,
      active: value && value.icon,
      onClick: function onClick() {
        setFieldValue(name, option);

        if (onChange) {
          onChange(option);
        }
      }
    }, option.description);
  });
};

SmileField.defaultProps = {
  options: [{
    icon: 'smile',
    description: 'Smiley face',
    placeholder: 'What do you like?'
  }, {
    icon: 'meh',
    description: 'Meh face',
    placeholder: 'What would you improve?'
  }, {
    icon: 'frown',
    description: 'Frowny face',
    placeholder: "What don't you like?"
  }]
};
export default SmileField;